import logo from './logo.svg';
import './App.css';
import LandingPageComponent from './components/LandingPageComponent';
import MultiSelectTest from './components/MultiSelectTest';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PersonList from '../src/components/person'
import Funnel from '../src/components/Funnel'
import ExportFeature from '../src/components/export/ExportFeature'
import Gender from './components/RadioButton/Gender';
import FullScreenComponent from './components/FullScreen/FullScreenComponent'
import Construction from './components/Construction';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path="/list" element={<PersonList />}/>
        <Route path="/demo" element={<MultiSelectTest />} />
        <Route path="/export" element={<ExportFeature/>} />
        <Route path="/gender" element={<Gender/>} />
        <Route path="/fullscreen" element={<FullScreenComponent/>} />
        <Route path="/" element={<LandingPageComponent />} /> */}
         <Route path="/" element={<Construction/>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
